export function GetMockCaseNoteRead() {
  return {
    id: 1,
    dateAdded: "2022-05-03T15:40:01.3153535",
    noteText:
      "client has own broker and AIP in place. doesnt wish to proceed with us",
    caseId: 424,
    addedByUserId: 14,
    isDeleted: 0,
    deletedDate: "0001-01-01T00:00:00",
  };
}
